// @flow

import React, { type Node } from 'react';

import { useIncomingPayment, getPaymentType, getCountry } from '@tectonics/prs/incoming-payment';

import { BoletoPendingPage } from './boleto';
import { CashPendingPage } from './cash';
import { EfectyPendingPage } from './cash/colombia';
import { PagoefectivoPendingPage } from './pagoefectivo';
import { PaynetPendingPage } from './paynet';
import { RedirectPage } from './redirect';
import { SpeiPendingPage } from './spei';
import { PixPendingPage } from './pix';

export function PaymentMethod(): Node {
  const incomingPayment = useIncomingPayment();
  const paymentType = getPaymentType(incomingPayment);
  const country = getCountry(incomingPayment);

  switch (paymentType) {
    case 'boleto':
      return <BoletoPendingPage />;

    case 'cash': {
      switch (country) {
        case 'ar':
          return <CashPendingPage />;

        case 'co':
          return <EfectyPendingPage />;

        default:
          return <CashPendingPage />;
      }
    }

    case 'oxxopay':
      return <CashPendingPage />;

    case 'paynet':
      return <PaynetPendingPage />;

    case 'pagoefectivo':
      return <PagoefectivoPendingPage />;

    case 'spei':
      return <SpeiPendingPage />;

    case 'banktransfer':
    case 'eft':
    case 'multicaja':
    case 'ewallet':
    case 'safetypay-cash':
    case 'safetypay-online':
    case 'safetypay':
    case 'sencillito':
    case 'servipag':
    case 'webpay':
    case 'externalpayprovider':
      return <RedirectPage />;

    case 'pix':
      return <PixPendingPage />;

    default:
      throw new Error(`Pending Page: payment type: ${String(paymentType)} is not implemented`);
  }
}
